import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import styled from 'styled-components';
import { PropTypes } from 'prop-types';
import { up } from 'styled-breakpoints';

const IconWrap = styled.div`
    font-size: 0.6em;

    ${up('md')} {
        font-size: 0.85em;
    }

    ${up('lg')} {
        font-size: 1em;
    }
`;

function ProgressBarIcon(props) {
    return (
        <IconWrap>
            <FontAwesomeIcon style={{marginRight: '15px'}} size='2x' icon={props.icon} color={props.active ? 'black' : 'lightgrey'} />            
        </IconWrap>
    )
}

ProgressBarIcon.propTypes = {
    icon: PropTypes.object.isRequired,
    active: PropTypes.bool.isRequired,
};

export default ProgressBarIcon;